import Collection from '../collection';
import Config from '../config';
import DataTable from '../model/datatable';





export default Collection.extend( {
    getUrl() {
		let url = `datatables`;
		for (let name in this.filters) if (this.filters.hasOwnProperty( name ))
            if (undefined !== this.filters[name])
			    url = Config.add( url, name, this.filters[name] );
		
        url = Config.url( url, { addToken: true, addBase: false } );
        if (this.page)
            url = Config.add( url, 'page', this.page );

        return url;
	},

	endpoint: 'datatables',
	model: DataTable,
	jsonp: false,
} );


// WEBPACK FOOTER //
// ./src/js/collection/datatables.js